import React from "react";

export default function Journey(props) {
  return (
    <section
      ref={props.refs}
      id="journey"
      aria-label="Career journey"
      className="bg-[rgba(247,250,251,1)] py-10 sm:py-20"
    >
      <div className="w-full flex">
        <h2
          className="text-4xl sm:text-6xl lg:text-6xl sm:my-10 md:my-50 mx-auto font-semibold bg-gradient-to-r from-blue-900 to-teal-600 bg-clip-text text-transparent text-center inline-block"
        >
          My Journey
        </h2>
      </div>

      <div className="mx-auto max-w-5xl flex flex-col md:flex-row items-center gap-8">
        {/* Left: Lottie Animation
        <div className="w-full md:w-1/2">
          <Lottie
            options={lottieOptions}
            height={'100%'}
            width={'100%'}
          />
        </div>
         */}

        {/* Right: Canva Embed */}
        <div className="w-full md:w-2/2">
          <div
            style={{
              position: "relative",
              width: "100%",
              height: 0,
              paddingTop: "56.25%",
              paddingBottom: 0,
              boxShadow: "0 2px 8px 0 rgba(63,69,81,0.16)",
              marginTop: "1.6em",
              marginBottom: "0.9em",
              overflow: "hidden",
              borderRadius: "8px",
              willChange: "transform"
            }}
          >
            <iframe
              title="My Journey Canva Timeline"
              loading="lazy"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
                border: "none",
                padding: 0,
                margin: 0
              }}
              src="https://www.canva.com/design/DAHQE4PH5hA/iVaXURqZbzD4riqjSD8Otg/view?embed"
              allowFullScreen
              allow="fullscreen"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
